export enum UserRole {
  JOONENGINEER = 'JoonEngineer',
  EMPLOYEE = 'Employee',
  EMPLOYERADMIN = 'EmployerAdmin',
  PROGRAMADMIN = 'ProgramAdmin',
  FINANCEADMIN = 'FinanceAdmin'
}

export enum SimplifiedUserPermission {
  ADMIN = 'Admin',
  NONE = 'None',
  JOONENGINEER = 'JoonEngineer'
}
